import React, { useContext, useState } from "react";
import { NavLink } from "react-router-dom";

import { auth } from "../Utils/firebase";
import { AuthContext } from "../context/AuthContext";

function SideMenu() {
  const [alert, setAlert] = useState(false);
  const { logout, setUserData } = useContext(AuthContext);

  const handleLogout = (e) => {
    e.preventDefault();
    document.body.style.removeProperty("overflow");

    auth
      .signOut()
      .then(() => {
        // Sign-out successful.

        logout();
        setUserData(null);
      })
      .catch((error) => {
        // An error happened.
        console.log(error);
      });
  };

  const openAlert = (id) => {
    setAlert(true);
    document.body.style.overflow = "hidden";
  };
  const closeAlert = () => {
    setAlert(false);
    document.body.style.removeProperty("overflow");
  };

  // LINK EKSTERNAL
  const goTo = (link) => {
    let url = "";
    switch (link) {
      case "flipcard":
        url = "https://flipcard.xyz/cholis04";
        break;
      default:
        break;
    }

    if (url !== "") {
      window.open(url, "_blank", "noopener");
      // window.open(url, "_blank", "noopener noreferrer");
    }
  };

  return (
    <div className="menu-side darkdivColor divContent">
      {alert && (
        <div className="alert">
          <div className="alert-box">
            <h5>Are you sure ?</h5>
            <p>This action cannot be undone!</p>
            <div className="option-wrap">
              <button onClick={handleLogout}>Yes</button>
              <button onClick={closeAlert}>Cancel</button>
            </div>
          </div>
        </div>
      )}
      <h5 className="darktextColor textTitle">Menu</h5>
      <ul>
        <li>
          <NavLink
            exact
            to="/main/dashboard"
            className="darktextColor text"
            activeClassName="link-active-1"
          >
            Dashboard
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/main/profile"
            className="darktextColor text"
            activeClassName="link-active-1"
          >
            Profile
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/main/appearance"
            className="darktextColor text"
            activeClassName="link-active-1"
          >
            Appearance
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/main/link"
            className="darktextColor text"
            activeClassName="link-active-1"
          >
            Link
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/main/analytic"
            className="darktextColor text"
            activeClassName="link-active-1"
          >
            Analytics
          </NavLink>
        </li>
      </ul>
      <hr color="#3c3c3c" />
      <ul className="footer-link">
        <li>
          <p className="textSmall darktextColor">
            Made with 💛 by{" "}
            <span onClick={() => goTo("flipcard")}>cholis04</span>
          </p>
        </li>
      </ul>

      <div className="button-wrap">
        <button onClick={openAlert}>Sign Out</button>
      </div>
    </div>
  );
}

export default SideMenu;
